import { render, staticRenderFns } from "./imageproducttaskmanager.vue?vue&type=template&id=3a5fbea8&scoped=true&"
import script from "./imageproducttaskmanager.vue?vue&type=script&lang=ts&"
export * from "./imageproducttaskmanager.vue?vue&type=script&lang=ts&"
import style0 from "./imageproducttaskmanager.vue?vue&type=style&index=0&id=3a5fbea8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fbea8",
  null
  
)

export default component.exports